import { getCopilotFileDownloadUrl as e, getCopilotFilesDownloadUrls as t } from "../file-download.js";
import { useCallback as n } from "react";
//#region src/react/file-download.ts
function r(r) {
	return {
		getFileDownloadUrl: n(async (t) => r == null ? "" : await e(r, t), [r]),
		getFilesDownloadUrls: n(async (e) => r == null ? [] : await t(r, e), [r])
	};
}
//#endregion
export { r as useCopilotFileDownload };
